import React from 'react';
import { useForm } from '../../contexts/FormContext';
import InputField from '../common/InputField';
import styles from './DataPribadiForm.module.css'; // Menggunakan style yang sama dengan DataPribadiForm

const StatusKesehatanForm = () => {
    const { 
        formData, 
        handleChange, 
        errors 
    } = useForm();

    // Selector untuk nilai dalam nested object
    const getValue = (field) => {
        return formData.status_kesehatan ? formData.status_kesehatan[field] || '' : '';
    };

    // Handler untuk input dalam nested object
    const handleNestedChange = (e) => {
        const { name, value } = e.target;
        const fieldName = name.split('.')[1]; // Ambil nama field setelah "status_kesehatan."

        const updatedStatusKesehatan = {
            ...formData.status_kesehatan,
            [fieldName]: value
        };

        // Gunakan event object tiruan untuk handler form context
        const syntheticEvent = {
            target: {
                name: 'status_kesehatan',
                value: updatedStatusKesehatan
            }
        };

        handleChange(syntheticEvent);
    };

    // Helper untuk mendapatkan error message untuk field dalam nested object
    const getError = (field) => {
        const errorKey = `status_kesehatan.${field}`;
        return errors[errorKey];
    };

    const golonganDarahOptions = [
        { value: '', label: 'Pilih golongan darah' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'AB', label: 'AB' },
        { value: 'O', label: 'O' },
        { value: 'A+', label: 'A+' },
        { value: 'A-', label: 'A-' },
        { value: 'B+', label: 'B+' },
        { value: 'B-', label: 'B-' },
        { value: 'AB+', label: 'AB+' },
        { value: 'AB-', label: 'AB-' },
        { value: 'O+', label: 'O+' },
        { value: 'O-', label: 'O-' },
        { value: 'Tidak Tahu', label: 'Tidak Tahu' }
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Status Kesehatan</h2>
            <p>Silakan isi informasi kesehatan jamaah untuk keperluan medis selama perjalanan.</p>

            <div className={styles.formSection}>
                <InputField
                    label="Golongan Darah"
                    name="status_kesehatan.golongan_darah"
                    value={getValue('golongan_darah')}
                    onChange={handleNestedChange}
                    error={getError('golongan_darah')}
                    select
                    options={golonganDarahOptions}
                />

                <InputField
                    label="Riwayat Penyakit"
                    name="status_kesehatan.riwayat_penyakit"
                    value={getValue('riwayat_penyakit')}
                    onChange={handleNestedChange}
                    error={getError('riwayat_penyakit')}
                    textarea
                    rows={3}
                    placeholder="Contoh: diabetes, hipertensi, asma, dll. (Kosongkan jika tidak ada)"
                    helperText="Tuliskan riwayat penyakit yang pernah/sedang diderita"
                />

                <InputField
                    label="Alergi"
                    name="status_kesehatan.alergi"
                    value={getValue('alergi')}
                    onChange={handleNestedChange}
                    error={getError('alergi')}
                    textarea
                    rows={3}
                    placeholder="Contoh: alergi makanan laut, alergi obat tertentu, dll. (Kosongkan jika tidak ada)"
                    helperText="Tuliskan alergi yang dimiliki"
                />

                <InputField
                    label="Obat Rutin"
                    name="status_kesehatan.obat_rutin"
                    value={getValue('obat_rutin')}
                    onChange={handleNestedChange}
                    error={getError('obat_rutin')}
                    textarea
                    rows={3}
                    placeholder="Contoh: insulin, obat darah tinggi, dll. (Kosongkan jika tidak ada)"
                    helperText="Tuliskan obat-obatan yang rutin dikonsumsi"
                />
            </div>
        </div>
    );
};

export default StatusKesehatanForm;